import React,{useState} from "react";
import './AlbumDetails.css'
import BackIcon from './../../../../images/backicon.png'
import {useNavigate} from "react-router-dom";
import { Trans, useTranslation} from 'react-i18next'
import playsongicon from './../../../../images/playsongicon.png'
import { useLocation } from "react-router-dom";

function AlbumDetails() {
    const { state } = useLocation();
    const [album,setAlbum] = useState(state.album)
    const navigate = useNavigate();
    const {t, i18n } = useTranslation();
    const [albumAnalyticsOption,setAlbumAnalyticsOption] = useState(1)

    return (
        <div style={{display:'flex',flexDirection:'column',width:"100%"}}>
                    <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end',justifyContent:'flex-start',width:'95%',alignSelf:'center'}}>
                                            <img src={BackIcon} alt="back icon" style={{width:'1.7em',height:'1.7em',cursor:'pointer'}} onClick={()=>navigate("/Dashboard/music")}/>
                                            <div className="MusicHeader" style={{color:'#FFFFFF',cursor:'pointer',textDecoration:'underline'}} onClick={()=>{navigate("/Dashboard/music")}}>All</div>
                                            <div className="MusicHeader" style={{paddingLeft:'0.7em'}}>/&nbsp; &nbsp;{album.name}</div>
                    </div>

                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'90%',borderRadius:'8px',marginLeft:'2.5em',marginTop:'2.5em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                      
                        <img src={album.image} alt="Album Cover Img" className="AlbumInfoCover"/>

                        <div style={{display:'flex',flexDirection:'column',marginTop:'1.5em'}}>
                            <div className="AlbumInfoHeader">{t('Album')}</div>
                            <div className="AlbumInfoName">{album.name}</div>
                            {
                                album.status === "PENDING" &&
                                <div className="AlbumInfoStatus">{t('Pendingstatus')}</div>
                            }

                            {
                                album.status === "RELEASED" &&
                                <div className="AlbumInfoStatus" style={{color:'#60E5C5'}}>{t('Releasedstatus')}</div>
                            }
       
                            <div style={{display:'flex',flexDirection:'row',marginLeft:'5em'}}>
                                <div style={{display:'flex',flexDirection:'column'}}>
                                    <div className="MetadataLabel">{t('Artisttag')}</div>
                                    <div className="MetadataLabel">{t('Labeltag')}</div>
                                    <div className="MetadataLabel">{t('Genretag')}</div>
                                    <div className="MetadataLabel">{t('Releasedatetag')}</div>
                                    <div className="MetadataLabel">{t('Formattag')}</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'column'}}>
                                    <div className="MetadataInfo">{album.artist}</div>
                                    <div className="MetadataInfo">{album.label}</div>
                                    <div className="MetadataInfo">{album.genre}</div>
                                    <div className="MetadataInfo">{album.releasedate}</div>
                                    <div className="MetadataInfo">{album.format}</div>
                                </div>
                            </div>
                         
                        </div>
                    </div>

                   
                <div style={{display:'flex',flexDirection:'column',width:'90%',borderRadius:'8px',paddingBottom:'1.5em',marginLeft:'2.5em',marginTop:'1em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em',width:'90.38%',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em'}}>
                        <div className="TrackTableHeader" style={{width:'8%'}}>  </div>
                        <div className="TrackTableHeader" style={{width:'25%'}}>{t('Name')}</div>
                        <div className="TrackTableHeader" style={{width:'20%'}}>{t('Artist')}</div>
                        <div className="TrackTableHeader" style={{width:'30%'}}>{t('Duration')}</div>
                 
                    </div>

                    <div style={{backgroundColor:'#595959',height:'1px',width:'90.38%',marginTop:'0.8em',marginBottom:'0.1em',marginLeft:'2.5em'}}/>

                    {
                        album.tracks.map((track,index)=>{
                        return (
                            <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{navigate("/Dashboard/music/trackdetails",{state:{track:track,album:album}})}}>
                                <div className="TrackTableRow" style={{width:'8%'}}>{index+1}</div>
                                <div className="TrackTableRow" style={{width:'25%'}}>{track.trackname}</div>
                                <div className="TrackTableRow" style={{width:'20%'}}>{track.songwriters}</div>
                                <div className="TrackTableRow" style={{width:'30%'}}>{track.tracklength}</div>
                                {/* <div className="TrackTableRow">$0.99</div> */}
                                <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
                            </div>
                        )
                        }
                        )
                    }
                    
                    {/* <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
                        <div className="TrackTableRow" style={{width:'8%'}}>1.</div>
                        <div className="TrackTableRow" style={{width:'25%'}}>Echoes of Yesterday</div>
                        <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
                        <div className="TrackTableRow" style={{width:'30%'}}>3:20</div>
                        <div className="TrackTableRow">$0.99</div>
                        <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
                    </div>

                    <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
                        <div className="TrackTableRow" style={{width:'8%'}}>2.</div>
                        <div className="TrackTableRow" style={{width:'25%'}}>Ripples</div>
                        <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
                        <div className="TrackTableRow" style={{width:'30%'}}>2:45</div>
                        <div className="TrackTableRow">$0.99</div>
                        <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
                    </div> */}
                    
                </div>

                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'90%',borderRadius:'8px',paddingBottom:'1.5em',marginLeft:'2.5em',marginTop:'1em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'center',marginTop:'3em',width:'100%',alignSelf:'center'}}>
                        {
                            albumAnalyticsOption===1 &&
                            <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
                               {t('1wk')} 
                            </div>
                        }

                        {
                            albumAnalyticsOption!==1 &&
                            <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
                               {t('1wk')} 
                            </div>
                        }

                        {
                            albumAnalyticsOption===2 &&
                            <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
                               {t('1mo')} 
                            </div>
                        }

                        {
                            albumAnalyticsOption!==2 &&
                            <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
                               {t('1mo')} 
                            </div>
                        }

                        {
                            albumAnalyticsOption===3 &&
                            <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
                               {t('All')} 
                            </div>
                        }

                        {
                            albumAnalyticsOption!==3 &&
                            <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
                                {t('All')} 
                            </div>
                        }                       

                    </div>

                    <div className="StreamsTxt">
                           {t('Streams')} 
                    </div>
                    
                    {
                       albumAnalyticsOption===1 && 
                       <div className="StreamsNo">
                       85.5k
                        </div>
                    }

                    {
                       albumAnalyticsOption===2 && 
                       <div className="StreamsNo">
                       402k
                        </div>
                    }

                    {
                       albumAnalyticsOption===3 && 
                       <div className="StreamsNo">
                       1.93M
                        </div>
                    }   
                 
                </div>
            </div>
    );
}

export default AlbumDetails;